import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Hero } from "../components/home/Hero";
import { SocialProofStrip } from "../components/home/SocialProofStrip";
import { HowItWorks } from "../components/home/HowItWorks";
import { Features } from "../components/home/Features";
import { About } from "../components/home/About";
import { AppPreview } from "../components/home/AppPreview";
import { FeaturedBooks } from "../components/home/FeaturedBooks";
import { Concierge } from "../components/home/Concierge";
import { BookNotes } from "../components/home/BookNotes";
import { Pricing } from "../components/home/Pricing";
import { FAQSection } from "../components/home/FAQSection";
import { DownloadCTA } from "../components/home/DownloadCTA";

export default function Home() {
    return (
        <div
            data-testid="home-page"
            className="bg-[#FDF6EE] text-[#2D2D2D] min-h-screen"
        >
            <Navbar />
            <Hero />
            <SocialProofStrip />
            <HowItWorks />
            <Features />
            <About />
            <AppPreview />
            <FeaturedBooks />
            <Concierge />
            <BookNotes />
            <Pricing />
            <FAQSection />
            <DownloadCTA />
            <Footer />
        </div>
    );
}
